import React from 'react';
import { TextAreaField } from '../../../shared/TextAreaField';

function RejectTicketForm(props) {
  return (
    <TextAreaField
      name="reason"
      messageId="components.pages.ticket.forms.rejectTicket.reason"
      handleBlur={props.formikProps.handleBlur}
      handleChange={value => props.formikProps.setFieldValue( 'reason', value )}
    />
  );
}

export { RejectTicketForm };
